import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { ForgePioSharepointIcon, ForgePioSharepointSearchResultIcon } from './icon';

export const forgePioSharepointConfig: ThirdPartyConfig = {
	displayName: 'SharePoint by Pio',
	id: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
	resourceType: ProductResourceTypes3P.ForgePioSharepointProd,
	icon: get3PLogo(ForgePioSharepointIcon, 'ForgePioSharepoint', 'medium'),
	searchResultIcon: get3PLogo(ForgePioSharepointSearchResultIcon, 'ForgePioSharepoint', 'large'),
	integrationAri: 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
